<template>
  <div class="content">
    <div class="c_position">
      <span class="el-icon-location-outline"></span>
      <label>你现在的位置：</label>
      <label><span @click="routerNav()">首页</span>>人才招聘</label>
    </div>
    <div class="profile">
      <div class="p_left">
        <div style="cursor:auto">人才招聘</div>
        <div class="change">
          <label>人才招聘</label>
        </div>
      </div>
      <div class="p_right">
        <div class="p_type">人才招聘</div>
        <div class="p_text">
          <div class="c_mes c_mes2">
            <ul>
              <li v-for="(item,index) in listChild" :key="index">
                <!-- <span class="icon_top" v-if="item.isTop==1">置顶</span> -->
                <span class="first_text" @click="jump(item.id)">{{item.title|dataShow}}</span>
                <span class="c_date">{{item.createTime|dataFormat}}</span>
              </li>
            </ul>
          </div>
          <div class="block">
            <el-pagination
              background
              :current-page.sync="pageNum"
              @current-change="handleSizeChange"
              
              layout=" prev, pager, next, total, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      limit:9,
      pageNum:1,
      total:0,
      list:[],
      listChild:[]
    };
  },
  filters: {
    dataFormat(msg) {
      var rs = msg.slice(0, 10);
      return rs;
    },dataShow(msg) {
      if (msg.length >= 40) {
        var res = msg.slice(0, 40) + "...";
        return res;
      } else {
        return msg;
      }
    },
  },
  methods:{
        routerNav(){
      this.$router.push({ path: "/home" });
    },
    req() {
      //2
      // http://localhost:9966/api/article/findArticalList?columnId=f7ad8282b445420c9a15959bab408352&pageNum=1&limit=10&type=1
      this.$axios({
        method: "GET",
        url: "/tourist/findArticalList",
        params: {
          columnId: this.list[0].value,
          pageNum: this.pageNum,
          limit: this.limit,
          type: "1",
        },
      }).then((respone) => {
        // console.log(respone.data.data,'------------------');
        this.total = respone.data.data.total; //改 获取的总条数
        this.listChild = respone.data.data.list;
        // this.pageNum = 1;
        // this.pageNum = respone.data.data.pageNum;
      });
      //2
    },
    handleSizeChange(page){
      // console.log(page)
      this.pageNum = page;
      this.req();
    },
    pre(){
      this.pageNum -= 1;
      this.req();
    },
    nex(){
      this.pageNum += 1;
      this.req();
    },
    jump(data){
        this.$router.push({
        path: "/ContentDetails",
        query: { pos1: "人才招聘", pos2: "" ,data:data},
      });
    }
  },
  mounted(){
    // window['ptext'] = (num) => {
    //     this.ptext(num)
    // }
    var id = window.sessionStorage.getItem("rczp");
      this.$axios({
      method: "GET",
      url: "/tourist/findColumnByParentIdAndMenuId",
      params: {
        parentId: id,
        menuSign: 1,
      },
    }).then((res) => {
      // console.log(res.data.data, "-----------");
      this.list = res.data.data;
      // if (this.list !== []) {
      //   this.ptext(this.$route.query.num)
      // }

      //2
      // http://localhost:9966/api/article/findArticalList?columnId=f7ad8282b445420c9a15959bab408352&pageNum=1&limit=10&type=1
      this.$axios({
        method: "GET",
        url: "/tourist/findArticalList",
        params: {
          columnId: res.data.data[0].value,
          pageNum: this.pageNum,
          limit: this.limit,
          type: "1",
        },
      }).then((rest) => {
        // console.log(rest.data.data,'人才招聘');
        this.total = rest.data.data.total; //改 获取的总条数
        this.listChild = rest.data.data.list;
        this.req()
        window.scrollBy(0, -1000)
      });
      //2
    });
  }
};
</script>

<style lang='less' scoped>
.c_position {
  margin-left: 50%;
  transform: translate(-200%);
}
.profile {
  width: 1173px;
  height: 824px;
  // margin-left: 353px;
  margin-left: 50%;
  transform: translate(-50%);
  // margin:0 20%;
  display: flex;
  flex-direction: row;
  margin-top: 7px;
  .p_left {
    width: 258px;
    height: 730px;
    border: 1px solid #f6f6f6;
    display: flex;
    flex-direction: column;
    background-color: #fdfdfd;
    div {
      width: 258px;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      label {
        margin-left: 24px;
        margin-top: 20px;
      }
      label:hover {
        cursor: pointer;
      }
    }
    div:hover {
      cursor: pointer;
      background-color: rgba(241, 244, 247, 1);
      color: rgba(19, 71, 121, 1);
    }
    div:nth-child(1) {
      color: white;
      text-align: center;
      font-size: 18px;
      font-weight: 1000;
      background-color: #1b7aca;
    }
    div:nth-child(1):hover {
      cursor: none;
      background-color: none;
    }
  }
  .p_right {
    height: 824px;
    width: 915px;
    .p_type {
      margin-left: 28px;
      height: 60px;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      color: rgba(49, 104, 155, 1);
      font-size: 18px;
      line-height: 65px;
      font-weight: 1000;
      padding-left: 20px;
    }
    .p_text {
      margin-top: 19px;
      height: 744px;
      width: 872px;
      margin-left: 48px;
      span:hover {
        color: #101010;
        cursor:auto;
        text-decoration:none;
      }
      .c_date {
        color: #999ca1;;
        // margin-left:10px;
        margin-left: 10px;
        float: right;
        margin-right: 30px;
      }
    }
  }
  .c_mes2 {
    border: none;
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    width: 872px;
    height: 600px;
    ul{
      li{
        font-size: 16px;
        margin: 0px;
        border-bottom: 1px dashed #E9E9E9;
        height: 60px;
        padding: 0px;
        line-height: 60px;
      }
    }
  }
}
</style>